import React from 'react';
import styled from 'styled-components';
import { Input } from 'antd';
import ActionButton from '../ActionButton';

export const RBContainer = styled.div`
  display: inline-block;

  .ant-radio-button-wrapper {
    font-weight: normal;
    margin-right: 6px;
    border-radius: 4px;
    background-color: ${props => props.styles.backgroundColor};
    color: ${props => props.styles.color};
    border: none;
    &:hover {
      font-weight: normal;
      color: ${props => props.styles.color};
    }
  }
  .ant-radio-button-wrapper:first-child {
    border-left: none;
  }

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    background-color: ${props => props.styles.color};
    font-weight: bold;
    border: none;
    box-shadow: none;
    color: white;
    &:hover { color: white; }
  }
`;

export default styled.div`
  padding: 35px;
  > div {
    margin-bottom: 20px;
  }
  .work-summary {
    display: flex;
    > div {
      width: 100%;
      margin-right: 20px;
    }
  }
`;

export const AddPartButton = props => (
  <ActionButton {...props} style={{ padding: '0 8px', fontSize: 13 }}>
    Add a part
  </ActionButton>
);

export const TextArea = styled(Input.TextArea)`
  &.ant-input {
    max-width: 600px;
  }
`;

export const CommentContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;

  > div {
    flex-grow: 0.45;
  }
`;

export const QeTag = styled.div`
  border-radius: 5px;
  background-color: rgba(82, 196, 27, 0.1);
  font-size: 10px;
  font-weight: 700;
  font-style: normal;
  font-stretch: normal;
  text-transform: uppercase;
  letter-spacing: 0.71px;
  text-align: center;
  display: inline-block;
  color: #52c41b;
  padding: 5px;
  line-height: 1;

 i {
    margin-right: 5px;
  }
`;
